<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <!-- <b-card>
        <div slot="header">User Profile</div>-->
        <b-form @submit.prevent="save">
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Email Address</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{
                      testred: $v.contact.contact_edit.Email1.$error
                    }"
                    v-model="contact.contact_edit.Email1"
                    placeholder="Required"
                    autocomplete="off"
                    type="text"
                    id="Email1"
                    @input="$v.contact.contact_edit.Email1.$touch()"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-user appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >First Name</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{
                      testred: $v.contact.contact_edit.FirstName.$error
                    }"
                    v-model="contact.contact_edit.FirstName"
                    placeholder="Required"
                    type="text"
                    id="FirstName"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                    @input="$v.contact.contact_edit.FirstName.$touch()"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-address-book appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Last Name</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{
                      testred: $v.contact.contact_edit.LastName.$error
                    }"
                    v-model="contact.contact_edit.LastName"
                    placeholder="Required"
                    type="text"
                    id="LastName"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                    @input="$v.contact.contact_edit.LastName.$touch()"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-address-book appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Address</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="contact.contact_edit.Address1"
                    type="text"
                    id="Address1"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-address-book appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Building/Suite</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="contact.contact_edit.Address2"
                    type="text"
                    id="Address2"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-address-book appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >City</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="contact.contact_edit.City"
                    type="text"
                    id="City"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-address-book appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >State/Province</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="contact.contact_edit.State"
                    type="text"
                    id="State"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-address-book appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Postal Code</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="contact.contact_edit.Zip"
                    type="text"
                    id="Zip"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-address-book appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Country</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="contact.contact_edit.Country"
                    type="text"
                    id="Country"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-address-book appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Phone</b-input-group-text
                    >
                  </b-input-group-prepend>

                  <b-form-input
                    v-model="contact.contact_edit.Phone1"
                    type="text"
                    id="Phone1"
                    v-mask="'(###) ###-####'"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>

                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-phone appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Mobile</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="contact.contact_edit.Phone2"
                    type="text"
                    v-mask="'(###) ###-####'"
                    id="Phone2"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-phone appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <div class="form-group form-actions" style="float:left;">
            <!-- <b-button
              v-if="
                contact.contact_edit.UserProfileID != -1 &&
                  contact.contact_edit.UserGroupID !== 2
              "
              class="mr-2 mt-2"
              style="color: white;"
              size="md"
              variant="green active"
              @click="DashRouteTo('/points/ledger')"
            >
              <i class="fa fa-dollar"></i>
              Reward Points</b-button
            > -->
          </div>
          <div class="form-group form-actions" style="float:right;">
            <b-button
              class="mr-2 mt-2"
              size="md"
              variant="outline-primary"
              @click="back"
            >
              <!-- <i class="fa fa-close"></i> -->
              Cancel
            </b-button>
            <b-button
              class="mr-0 mt-2"
              size="md"
              variant="primary"
              type="submit"
              :disabled="isClean"
            >
              <i class="fa fa-save"></i>
              Save
            </b-button>
          </div>
          <div class="form-group form-actions" style="float:right;">
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismissCountDown"
              fade
              variant="light"
              :dismissed="(dismissCountdown = 0)"
              @dismiss-count-down="countDownChanged"
            >
              Your information has been saved
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismiss2CountDown"
              fade
              variant="danger"
              :dismissed="(dismiss2Countdown = 0)"
              @dismiss-count-down="countDown2Changed"
            >
              Your information could not be saved. Check all fields carefully.
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismiss3CountDown"
              fade
              variant="danger"
              :dismissed="(dismiss3Countdown = 0)"
              @dismiss-count-down="countDown3Changed"
            >
              User already exists! Your information could not be saved.
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
          </div>
        </b-form>
        <!-- </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { required, email, minLength, helpers } from "vuelidate/lib/validators";
import { CoolSelect } from "vue-cool-select";
import ImageModal from "@/components/dialogs/ImageModal.vue";
const alpha = helpers.regex("alpha", /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/);
export default {
  name: "PlayerProfile",
  data() {
    return {
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      dismiss3Secs: 3,
      dismiss3CountDown: 0,
      showDismissibleAlert: false,
      isAvatarLoading: false,
      selectedImageUrl: ""
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    countDown3Changed(dismiss3CountDown) {
      this.dismiss3CountDown = dismiss3CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store.state.saveOp.localUrl = "/Contact/Save/";
        this.$store.state.saveOp.localVariableName = "_c";
        this.$store.state.saveOp.localVariableObject = this.$store.state.contact.contact_edit;
        this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
        this.$store.state.saveOp.localFieldToSet = "ContactID";
        this.$store.state.saveOp.localReturnObject = "SaveContactResult";
        //this.$store.state.contact.contact_edit[:UserProfileID];

        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = []),
                (this.dismissCountDown = this.dismissSecs),
                this.$store.state.saveOp.DestroySaveOperation
              )
          );
      }
    },
    addDirtyField: function(event) {
      if (event.which !== 9 && event.which !== 13) {
        this.dirtyFields = this.dirtyFields.filter(
          dirtyField => dirtyField.FieldName !== event.target.id
        );
        this.dirtyFields.push({
          FieldName: event.target.id,
          FieldValue: event.target.value
        });
      }
    },
    addDirtyFieldWatch: function(field, newValue) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== field
      );
      this.dirtyFields.push({
        FieldName: field,
        FieldValue: newValue
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldRadio: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== "IsSU"
      );
      this.dirtyFields.push({
        FieldName: "IsSU",
        FieldValue: event.target.value
      });
    },
    addDirtyFieldSwitch: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.checked.toString()
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },

    DashRouteTo(_page) {
      this.save();
      this.$router.push(_page);
    }
  },
  computed: {
    ...mapState(["n_user", "contact", "saveOp", "global"]),
    ...mapActions("n_user", ["Save"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    isClean() {
      return this.dirtyFields.length === 0;
    }
  },
  components: {
    CoolSelect
  },
  validations: {
    contact: {
      contact_edit: {
        Email1: {
          required,
          email
          //minLength: minLength(7)
        },
        FirstName: {
          required
        },
        LastName: {
          required
        },

        Zip: {
          minLength: minLength(5)
        },
        Phone1: {
          minLength: minLength(14)
        }
      }
    }
  },
  watch: {}
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
.testred {
  color: red;
  border-color: red;
}
</style>
